/**
 * Shared behaviour for the game pages (/games/<slug>): the game on top, the
 * guide below it.
 *
 * Every game listens for its keys on the document. While the board is scrolled
 * out of view those keys belong to the page again: arrows and space scroll it,
 * instead of moving pieces nobody can see. A capturing listener on window runs
 * before any of the games' listeners, so stopping the event there keeps them
 * out of it without each game needing to know. The browser's default action
 * (scrolling, activating a focused link) is untouched.
 */

import './immersive.js';
import './feedback.js';
import './challenge-banner.js';
import { isStageInView } from './stage-visibility.js';
import { isTextInputFocused } from '../utils/inputUtils.js';

window.addEventListener(
  'keydown',
  (event) => {
    // Typing in a form (the feedback form, say) is never the game's business,
    // and the form needs its own key handlers.
    if (isStageInView() || isTextInputFocused()) return;
    event.stopImmediatePropagation();
  },
  true,
);
